export const jsonApiTypes = {
  accountSearchRequest: 'account-search-request',
  eligibleFundsSearchRequest: 'eligible-funds-request',
  aipInstructionRequest: 'aip-instruction-request',
  aipInstructionSearchRequest: 'aip-instruction-search-request'
};
